import axios from 'axios';
import $ from 'jquery';
import { Dictionary_URL, DOWNLOADIMAGEFRA_URL, DOWNLOADIMAGEHWC_URL, IUSERBEHAVIOUR_URL } from '../services/end-url';
import CommonService from "../services/common.service";
import imageCompression from 'browser-image-compression';
import androidchrome from '../assets/images/Logos.png'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import '../assets/css/font/Banikanta-normal'
import ReactReadMoreReadLess from 'react-read-more-read-less';

export const GenerateToken = async (user) => {
  await axios.post(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api/Authenticate/Authenticate', {
    userName: "a@aa.com",
    password: "1234567",
    role: "na"
  }).then(function (response) {
    try {
      globalThis.config.Settings.token = response.data.jwtToken

    } catch (e) {
      alert(e.message.toString());
    }
  }).catch(function (error) {
    console.log(error);
  }).finally(function () {
  });
}
export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // reader.result is like: data:application/pdf;base64,xxxx
      const base64 = reader.result.split(",")[1]; // remove prefix if needed
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
export const GetMasterCommon = async (ids) => {
  try {
    let data;
    await axios.get(globalThis.config.Settings.ApiConfiguration.Host + globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api_common/CommonApi/' + ids, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }
    ).then(function (response) {
      data = response;
    }).catch(function (error) { data = null; }).finally(function () {

    });
    return data.data;
  } catch { }
}

//for arc gis
export const GetTokenArcGis = async (param) => {
  const api = axios.create({
    baseURL: globalThis.config.Settings.MapConfig.baseURL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  try {
    const response = await api.post('generateToken', param);
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}



export const GetCreateUserArcGis = async (param) => {
  try {
    const response = await axios.post(
      globalThis.config.Settings.MapConfig.createGISuserUrl,
      param,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': '*'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error.response); // Log error response for more details
    return null;
  }
}
export const GetDictionary = async (gids) => {

  let dictData = {};
  await AutoAuthenticate();
  await axios.get(globalThis.config.Settings.ApiConfiguration.Host + Dictionary_URL + "?id=" + gids,
    { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
    .then(function (response) {
      if (response.data) {
        response.data.forEach(function (idx) {
          if (globalThis.config.Settings.Locale == "en") {
            dictData[idx.message.trim().replace(/\s/g, '_')] = idx.translation_en;
          }
          else {
            dictData[idx.message.trim().replace(/\s/g, '_')] = idx.translation_as;
          }
        })
      }
    })
    .catch(function (error) {
      dictData = null;
    })
    .finally(function () {

    });
  return dictData;
}
export const GetDictionaryBothLanguage = async (gids) => {
  let dictData = { en: {}, as: {} };
  await axios.get(globalThis.config.Settings.ApiConfiguration.Host + Dictionary_URL + "?id=" + gids,
    { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } })
    .then(function (response) {
      if (response.data && Array.isArray(response.data)) {
        response.data.forEach((item) => {
          const key = item.message.trim().replace(/\s+/g, "_");
          dictData.en[key] = item.translation_en ?? "";
          dictData.as[key] = item.translation_as ?? ""; // Use Assamese translation if available
        });
      }
    })
    .catch(function (error) {
      dictData = null;
    })
    .finally(function () {

    });
  return dictData;
}
export const BindDropdownlocation = async (data, id, key, value) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='0' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='0' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>");
    })
  }
}
export const BindDropdown = async (data, id, key, value) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>");
    })
  }
}
export const BindDropdownNoBL = async (data, id, key, value) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    if (id == "employee_id") {
      data.sort((a, b) => a[value].localeCompare(b[value]));
    }
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value] + "</option>");
    })
  }
}

export const BindDropdownSingleSelected = async (data, id, key, value) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>");
    })
  }
  //single value selection
  if ($("#" + id + " option").length === 2) {
    $("#" + id + " option:eq(1)").attr('selected', 'selected');
  }
}

export const BindDropdownwithoutLang = async (data, id, key, value) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    if (id == "testclassifier_id") {
      data.sort((a, b) => a[value].localeCompare(b[value]));
    }
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value] + "</option>");
    })
  }
}

export const BindDropdownwithlabel = async (data, id, key, value, label) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + label + " - " + idx[value] + "</option>");
    })
  }
}
export const BindDropdownwithlabelCourtCase = async (data, id, key, value, label) => {
  $("#" + id).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("#" + id).append("<option value='' >--Choose--</option>");
  }
  else {
    $("#" + id).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      $("#" + id).append("<option value='" + idx[key] + "' >" + idx[value] + " - " + label + "</option>");
    })
  }
}

export const BindDropdownCSSClass = async (data, classname, key, value) => {
  $("." + classname).empty();
  if (globalThis.config.Settings.Locale == 'en') {
    $("." + classname).append("<option value='' >--Choose--</option>");
  }
  else {
    $("." + classname).append("<option value='' >--বাছনি কৰক--</option>");
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      $("." + classname).append("<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>");
    })
  }
}
export const GetOptionDropdown = async (data, key, value) => {
  var opt = "";
  if (globalThis.config.Settings.Locale == 'en') {
    opt += "<option value='' >--Choose--</option>";
  }
  else {
    opt += "<option value='' >--বাছনি কৰক--</option>";
  }
  if (data.length !== undefined && data.length > 0) {
    data.forEach(function (idx) {
      opt += "<option value='" + idx[key] + "' >" + idx[value + globalThis.config.Settings.Locale] + "</option>";
    })
  }
  return opt;
}
export const GetOptionChoose = async () => {
  var opt = "";
  if (globalThis.config.Settings.Locale == 'en') {
    opt += "<option value='' >--Choose--</option>";
  }
  else {
    opt += "<option value='' >--বাছনি কৰক--</option>";
  }
  return opt;
}
export const UpdateBGImage = async (img) => {
  document.getElementsByTagName('body')[0].style.background = `url('${img}') 0 0 no-repeat`;
  document.getElementsByTagName('body')[0].style.backgroundAttachment = `fixed`;
}

export const fileToDataUri = async (image) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      resolve({
        base64: reader.result,
      });
    });
    reader.readAsDataURL(image);
  });
};

export const fileCancel = async (event) => {
  if (event.target.value == '') {
    return false;
  }


}


export const MAX_FILE_SIZE = 1024  // 1MB
export const MAX_LENGTH = 5;

export const formatDate = (inputDate) => {
  if (inputDate == "-") { return; }
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
export const formatDateTime = (inputDate) => {
  if (inputDate == "-") { return; }
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  return `${day}-${month}-${year}` + " " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
}
export const formatDate_Time = (inputDate) => {
  const [datePart, timePart] = inputDate.split(" ");
  const [day, month, year] = datePart.split("-");
  const [hours, minutes] = timePart.split(":");
  const monthMap = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };
  return `${year}-${monthMap[month]}-${String(day).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
}
export const html5formatDateTime = (inputDate) => {
  // if (inputDate == "-") { return; }
  if (!inputDate || inputDate === "-") return;
  var now = new Date(inputDate);
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
}

export const downloadImage = async (url, imageName) => {
  const headers = { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` }
  const originalImage = globalThis.config.Settings.ApiConfiguration.Host + url + "?id=" + imageName;
  const image = await fetch(originalImage, { headers });
  const nameSplit = originalImage.includes("/DownloadDocumnet?id=") ? originalImage.split("/DownloadDocumnet?id=") : originalImage.split("/DownloadDocument?id=");
  const duplicateName = nameSplit.pop();
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)
  const link = document.createElement('a')
  link.href = imageURL;
  link.download = "" + duplicateName + "";
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return true;
};
export const FormatDate = (inputDate) => {
  if (!inputDate) return "";

  let date;

  // Handle both Date objects and strings
  if (inputDate instanceof Date) {
    date = inputDate;
  } else {
    date = new Date(inputDate);
    if (isNaN(date.getTime())) return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;  // → 01-Sep-2007
};
export const Format_Date = (inputDate) => {
  if (inputDate !== undefined && inputDate !== '') {
    const date = new Date(inputDate);
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  return '';
};
export const ToLocalISOString = (date) => {
  const localDate = new Date(date - date.getTimezoneOffset() * 60000);

  localDate.setSeconds(null);
  localDate.setMilliseconds(null);
  return localDate.toISOString().slice(0, -1);
}
export const getlogouttime_ub = () => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  var currentdate = new Date();
  var datetime = currentdate.getDate() + "-"
    + monthNames[(currentdate.getMonth() + 1)] + "-"
    + currentdate.getFullYear() + " "
    + currentdate.getHours() + ":"
    + currentdate.getMinutes() + ":"
    + currentdate.getSeconds();
  return datetime;
}
export const getdatetime_ub = () => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  var currentdate = new Date();
  var datetime = currentdate.getDate() + "-"
    + monthNames[(currentdate.getMonth() + 1)] + "-"
    + currentdate.getFullYear() + " "
    + currentdate.getHours() + ":"
    + currentdate.getMinutes() + ":"
    + currentdate.getSeconds();
  return datetime;
}

export const RandomColorHex = (index) => {
  let letters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  // HTML color code starts with #
  let color = '#';
  // Generating 6 times as HTML color code
  // consist of 6 letter or digits
  for (let i = 0; i < 6; i++) {
    color += letters[(Math.floor(Math.random() * 16))];
  }
  return color;
};

export const downloadImagefra = async (url, imageName) => {
  const originalImage = globalThis.config.Settings.ApiConfiguration.Host + DOWNLOADIMAGEFRA_URL + "?id=" + imageName;
  const image = await fetch(originalImage);
  const nameSplit = originalImage.split("=");
  const duplicateName = nameSplit.pop();
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)
  const link = document.createElement('a')
  link.href = imageURL;
  link.download = "" + duplicateName + "";
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return true;
};

export const downloadImagehwc = async (url, imageName) => {
  const originalImage = globalThis.config.Settings.ApiConfiguration.Host + DOWNLOADIMAGEHWC_URL + "?id=" + imageName;
  const image = await fetch(originalImage);
  const nameSplit = originalImage.split("=");
  const duplicateName = nameSplit.pop();
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)
  const link = document.createElement('a')
  link.href = imageURL;
  link.download = "" + duplicateName + "";
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return true;
};

export const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month because it's 0-based
  const day = now.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// export const WKTStringToArray = (wktString) => {
//   // Extract the coordinates part from the WKT string
//   const coordinatesPart = wktString.match(/\(\((.*?)\)\)/)[1];
//   const finalcoordinates = [];
//   // Split the coordinates into an array of coordinate strings
//   const coordinateStrings = coordinatesPart.split(', ');

//   // Convert each coordinate string to an array of [lon, lat] and parse as float
//   const coordinatesArray = coordinateStrings.map(coordString => {
//     const [lon, lat] = coordString.split(' ').map(parseFloat);
//     return [lon, lat];
//   });
//   finalcoordinates.push(coordinatesArray)
//   return finalcoordinates;
// }
export const WKTStringToArray = (wktString) => {
  const finalCoordinates = [];

  if (wktString.startsWith("POINT")) {
    // Extract coordinates from POINT WKT
    const coordinatesPart = wktString.match(/\((.*?)\)/)[1];
    const [lon, lat] = coordinatesPart.split(' ').map(parseFloat);
    // Return in [[[]]] format for compatibility with Polygon logic
    finalCoordinates.push([[lon, lat]]);
  } else if (wktString.startsWith("POLYGON")) {
    // Extract coordinates from POLYGON WKT
    const coordinatesPart = wktString.match(/\(\((.*?)\)\)/)[1];
    const coordinateStrings = coordinatesPart.split(', ');
    const coordinatesArray = coordinateStrings.map(coordString => {
      const [lon, lat] = coordString.trim().split(' ').map(parseFloat);
      return [lon, lat];
    });
    finalCoordinates.push(coordinatesArray);
  } else {
    console.warn("Unsupported WKT format:", wktString);
  }

  return finalCoordinates;
};

export const GetPermission = (resource_id, permission_id) => {
  let bool = false;
  let get_permission = JSON.parse(localStorage.getItem("accessmatrix")).Permissions
  if (typeof get_permission !== 'undefined' && get_permission != "") {
    get_permission.forEach((el) => {
      if (el.resource_id == resource_id && el.permission_id == permission_id) {
        bool = true;
        return bool;
      }
    });
  }

  return bool;
}
export const GetPermissionAll = async (resource_id) => {
  let permission = { view: false, add: false, edit: false, approve_reject: false, assign: false };
  let get_permission = JSON.parse(localStorage.getItem("accessmatrix")).Permissions
  if (typeof get_permission !== 'undefined' && get_permission != "") {
    get_permission.forEach((el) => {
      if (el.resource_id == resource_id && el.permission_id == 1) {
        permission.view = true;
      }
      else if (el.resource_id == resource_id && el.permission_id == 2) {
        permission.add = true;
      }
      else if (el.resource_id == resource_id && el.permission_id == 3) {
        permission.edit = true;
      }
      else if (el.resource_id == resource_id && el.permission_id == 4) {
        permission.approve_reject = true;
      }
      else if (el.resource_id == resource_id && el.permission_id == 5) {
        permission.assign = true;
      }
    });
  }
  return permission;
}
export const IsNumberKey = (e) => {
  // const isValidInput = /^[0-9\b]+$/.test(e.key);
  const isValidInput = /^[0-9\u09E6-\u09EF]+$/.test(e.key)
  if (!isValidInput) { e.preventDefault(); }
};
export const amountKey = (e) => {
  const isValidInput = /^[0-9,\b]+$/.test(e.key);
  if (!isValidInput) { e.preventDefault(); }
}
export const IsNumberMinus = (e) => {
  const isValidInput = /^[0-9.+-]*$/.test(e.key);
  if (!isValidInput) { e.preventDefault(); }
};

export const IsAlphabetNumber = (e) => {
  const isValidInput = /^[a-zA-Z0-9\u0980-\u09FF]$/.test(e.key);
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];

  if (!isValidInput && !controlKeys.includes(e.key)) {
    e.preventDefault();
  }
};

export const IsAlphabetKey = (e) => {
  // const isValidInput = /^[a-zA-Z\s]+$/.test(e.key);
  const isValidInput = /^[\u0980-\u09FFa-zA-Z\s]+$/.test(e.key); //Allow Assamese
  if (!isValidInput) { e.preventDefault(); }
};

export const Grade_IsAlphabetKey = (e) => {
  const isValidInput = /^[a-fA-F+-]+$/.test(e.key);
  if (!isValidInput) { e.preventDefault(); }
};

export const IsNumberDecimalKey = (e) => { // e.g. 23.5343
  const isValidInput = /^[0-9.]*$/.test(e.key);
  if (!isValidInput || ((e.target.value + '' + e.key).split('.').length > 2)) {
    e.preventDefault();
  }
};
export const IsDecimalKey = (e) => { //eg. 23.53
  // const isValidInput = /^[0-9.]*$/.test(e.key);
  const isValidInput = /^[\u0980-\u09FF0-9.]*$/; // Assamese chars + digits + dot
  if (!isValidInput || ((e.target.value + '' + e.key).split('.').length > 2 || (e.target.value + '' + e.key).split('.').length >= 2 && ((e.target.value + '' + e.key).split('.')[1]).length > 2)) {
    e.preventDefault();
  }
};

// E.g:- OnKeyPress={IsEmail}  -- allow only alphabet,numeric,@,.
export const IsEmail = (e) => {
  const isValidInput = /^[a-zA-Z0-9@._-]+$/.test(e.key);
  if (!isValidInput) {
    e.preventDefault();
  }
  return true
};

export const FileCompression = async (img) => {
  if (img.type.includes("image/")) {
    let img_name_size = await imageCompression(img, globalThis.config.Settings.img_compress_options);
    let img_base64 = await imageCompression.getDataUrlFromFile(img_name_size)
    return {
      name: img_name_size.name,
      size: img_name_size.size,
      img_base64: img_base64
    };
  } else {
    return {
      name: img.name,
      size: img.size,
      img_base64: (await fileToDataUri(img)).base64
    };
  }
};
export const Coord4326To3857 = async (coord) => {
  const X = 20037508.34;
  let long3857 = (coord.lng * X) / 180;
  let lat3857 = parseFloat(coord.lat) + 90;
  lat3857 = lat3857 * (Math.PI / 360);
  lat3857 = Math.tan(lat3857);
  lat3857 = Math.log(lat3857);
  lat3857 = lat3857 / (Math.PI / 180);
  lat3857 = (lat3857 * X) / 180;
  return { lat: lat3857, lng: long3857 };
}

export const Coord3857To4326 = async (coord) => {

  const e_value = 2.7182818284;
  const X = 20037508.34;

  const lat3857 = coord.lat
  const long3857 = coord.lng;

  //converting the longitute from epsg 3857 to 4326
  const long4326 = (long3857 * 180) / X;

  //converting the latitude from epsg 3857 to 4326 split in multiple lines for readability
  let lat4326 = lat3857 / (X / 180);
  const exponent = (Math.PI / 180) * lat4326;

  lat4326 = Math.atan(Math.pow(e_value, exponent));
  lat4326 = lat4326 / (Math.PI / 360); // Here is the fixed line
  lat4326 = lat4326 - 90;
  return { lat: lat4326.toFixed(4), lng: long4326.toFixed(4) };
}
export const Coord3857To4326_tofixed6 = async (coord) => {

  const e_value = 2.7182818284;
  const X = 20037508.34;

  const lat3857 = coord.lat
  const long3857 = coord.lng;

  //converting the longitute from epsg 3857 to 4326
  const long4326 = (long3857 * 180) / X;

  //converting the latitude from epsg 3857 to 4326 split in multiple lines for readability
  let lat4326 = lat3857 / (X / 180);
  const exponent = (Math.PI / 180) * lat4326;

  lat4326 = Math.atan(Math.pow(e_value, exponent));
  lat4326 = lat4326 / (Math.PI / 360); // Here is the fixed line
  lat4326 = lat4326 - 90;
  return { lat: lat4326.toFixed(6), lng: long4326.toFixed(6) };
}
export const wing_filter = async (data, currentUser) => {
  if (currentUser.lst_working_boudary == undefined || currentUser.lst_working_boudary == null) {
    return data;
  }
  let lst_working_boudary = currentUser.lst_working_boudary;
  if (lst_working_boudary.length > 0) {
    if (lst_working_boudary[0].wing_id != 0) {
      data = data.filter((row) => {
        return row.gid == lst_working_boudary[0].wing_id
      })
    }
  }
  return data;
}
export const zone_filter = async (data, currentUser) => {
  if (currentUser.lst_working_boudary == undefined || currentUser.lst_working_boudary == null) {
    return data;
  }
  let lst_working_boudary = currentUser.lst_working_boudary;
  if (lst_working_boudary.length > 0) {
    if (lst_working_boudary[0].zone_id != 0) {
      data = data.filter((row) => {
        return row.gid == lst_working_boudary[0].zone_id
      })
    }
  }
  return data;
}
export const circle_filter = async (data, currentUser) => {
  if (currentUser.lst_working_boudary == undefined || currentUser.lst_working_boudary == null) {
    return data;
  }
  let lst_working_boudary = currentUser.lst_working_boudary;
  if (lst_working_boudary.length > 0) {
    if (lst_working_boudary[0].circle_id != 0) {
      data = data.filter((row) => {
        return row.circle_id == lst_working_boudary[0].circle_id
      })
    }
  }
  return data;
}
export const division_filter = async (data, currentUser) => {
  if (currentUser.lst_working_boudary == null) {
    return data;
  }
  let lst_working_boudary = currentUser.lst_working_boudary;
  if (lst_working_boudary.length > 0) {
    if (lst_working_boudary[0].division_id != 0) {
      data = data.filter((row) => {
        return row.division_id == lst_working_boudary[0].division_id
      })
    }
  }
  return data;
}

export const range_filter = async (data, currentUser) => {
  if (currentUser.lst_working_boudary == null) {
    return data;
  }
  let lst_working_boudary = currentUser.lst_working_boudary;
  if (lst_working_boudary.length > 0) {
    if (lst_working_boudary[0].range_id != 0) {
      data = data.filter((row) => {
        return row.range_id == lst_working_boudary[0].range_id
      })
    }
  }
  return data;
}
export const beat_filter = async (data, currentUser) => {
  if (currentUser.lst_working_boudary == null) {
    return data;
  }
  let lst_working_boudary = currentUser.lst_working_boudary;
  if (lst_working_boudary.length > 0) {
    if (lst_working_boudary[0].range_id != 0) {
      data = data.filter((row) => {
        return row.range_id == lst_working_boudary[0].range_id
      })
    }
  }
  return data;
}

export const ub_analytics = async (commondata, resource_id, permission_id, logintime, logouttime) => {
  if (globalThis.config.Settings.UBA.resource_id == resource_id &&
    globalThis.config.Settings.UBA.permission_id == permission_id) {
    return;
  }
  //duplicate
  globalThis.config.Settings.UBA.resource_id = (resource_id != '' ? resource_id : -1);
  globalThis.config.Settings.UBA.permission_id = (permission_id != '' ? permission_id : -1);
  const currentdate = FormatDate(new Date());
  const response = await axios.get('https://api.ipify.org/?format=json')
  const paramuser = {
    "lst_userbehavior_analytics": {
      "analytics_id": 0,
      "application_id": 3,
      "islogin": true,
      "login_id": commondata.userid != '' ? commondata.userid : 0,
      "login_type": commondata.user_type != '' ? commondata.user_type : '',
      "resource_id": resource_id != '' ? resource_id : 0,
      "permission_id": permission_id != '' ? permission_id : 0,
      "ip_address": response.data.ip,
      "role_id": commondata.role_id != '' ? commondata.role_id : 0,
      "machine_name": "",
      "employee_id": commondata.userid != '' ? commondata.userid : 0,
      "login_time": logintime != '' ? logintime : '',
      "logout_time": logouttime != '' ? logouttime : '',
      "createdate": currentdate
    }
  }
  CommonService.create(IUSERBEHAVIOUR_URL, paramuser)
    .then(response => {
      response = response;
    })
}

export const AutoAuthenticate = async () => {
  try {
    const response = await axios.get(globalThis.config.Settings.ApiConfiguration.Host +
      globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api/Authenticate/AutoAuthenticate',
      { headers: { "security_key": globalThis.config.Settings.security_key } });
    if (response.data) {
      localStorage.setItem("jwtToken", response.data);
    }
  } catch (error) {
    console.error('Auto-authentication failed:', error);
  }
}

export const WKTStringToArray_new = (wktString) => {
  try {
    let polygonParts = null;
    if (wktString.startsWith('POLYGON')) {
      polygonParts = wktString.match(/\(\(([^()]+)\)\)/g);
      if (polygonParts == null) {
        polygonParts = wktString.match(/\(\s*(.*?)\s*\)/g);
      }
      if (polygonParts) {
        if (polygonParts.length === 1) {
          // Simple polygon case
          const coordinatesPart = polygonParts[0].substring(2, polygonParts[0].length - 2);
          const coordinateStrings = coordinatesPart.split(', ');
          const coordinatesArray = coordinateStrings.map(coordString => {
            const [lon, lat] = coordString.split(' ').map(parseFloat);
            return [lon, lat];
          });
          return [coordinatesArray];
        } else {
          // Polygon with holes case
          const rings = polygonParts.map((polygonPart, index) => {
            const coordinatesPart = index === 0 ?
              polygonPart.replace(/^\(\(\s*|\s*\)\)$/g, '') : // Remove leading and trailing double parentheses for outer polygon
              polygonPart.replace(/^\(\s*|\s*\)$/g, ''); // Remove leading and trailing parentheses for inner rings

            const coordinateStrings = coordinatesPart.split(', ');
            return coordinateStrings.map(coordString => {
              const [lon, lat] = coordString.split(' ').map(parseFloat);
              return [lon, lat]; // Reversed to [lon, lat] format
            });
          });

          return rings;
        }

      }
    } else if (wktString.startsWith('MULTIPOLYGON')) {
      // Multipolygon case
      const finalcoordinates = [];
      const polygonParts = wktString.match(/\(\(([^()]+)\)\)/g);
      polygonParts.forEach((polygonPart) => {
        const coordinatesPart = polygonPart.substring(2, polygonPart.length - 2);
        const coordinateSets = coordinatesPart.split('), (');
        coordinateSets.forEach((coordSet) => {
          const coordinateStrings = coordSet.split(', ');
          const coordinates = coordinateStrings.map((coordString) => {
            const [lon, lat] = coordString.split(' ').map(parseFloat);
            return [lon, lat];
          });

          finalcoordinates.push(coordinates);
        });
      });
      return finalcoordinates;
    } else {
      throw new Error('Unsupported WKT format: Only POLYGON and MULTIPOLYGON are supported.');
    }
  } catch (error) {
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};
export const calculateExperience = (startDate, endDate) => {
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    if (days < 0) {
      const prevMonth = new Date(end.getFullYear(), end.getMonth() - 1, start.getDate());
      days = (end - prevMonth) / (1000 * 60 * 60 * 24);
      months--;
    }

    if (months < 0) {
      months += 12;
      years--;
    }

    return ([(parseInt(years)), parseInt(months), parseInt(days)]);
  }
};

export const Pdf_log = async () => {
  const doc = new jsPDF();
  const logoUrl = androidchrome; // Replace with the path to your logo
  const logoWidth = 100; // Width of the logo
  const logoHeight = 20; // Height of the logo
  const padding = 12; // Space from the edge
  doc.addImage(logoUrl, 'PNG', padding, padding, logoWidth, logoHeight);
  return doc;
}
export const Pdf_Set_css = async () => {
  const logoHeight = 20; // Height of the logo
  const padding = 12; // Space from the edge
  const spaceBelowLogo = 7;
  const tableStartY = padding + logoHeight + spaceBelowLogo
  return tableStartY;
}

export const cleanString = (str) => {
  return str.replace(/[\n\r]+/g, ' ').replace(/['"]+/g, '').trim();
};

export const readMoreLessData = (char_limit, dic_lng, rowData) => {
  const myLongText = `${rowData} `;
  return (
    <ReactReadMoreReadLess
      charLimit={char_limit}  // Adjust the character limit as needed
      readMoreText={dic_lng['More'] + " ▼"}
      readLessText={dic_lng['Less'] + " ▲"}
    >
      {myLongText}
      {/* {myLongText}  */}
    </ReactReadMoreReadLess>
  );
};
export const IsAlphabetNumber_space = (e) => {
  // const isValidInput = /^[a-zA-Z0-9\s]+$/.test(e.key);
  const isValidInput = /^[\u0980-\u09FFa-zA-Z0-9\s]+$/.test(e.key); //Allow Assamese
  if (!isValidInput) { e.preventDefault(); }
};
export const Scroll_Top = (e) => {
  window.scrollTo({ top: 0, behavior: "auto" });
};
export const money_with_commas = (input) => {
  if (input == null) return '';
  const parts = input.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};
export const money_without_commas = (input) => {
  if (typeof input !== 'string') return input;
  return parseFloat(input.replace(/,/g, ''));
};
export const money_with_commas_offence = (input) => {
  if (input == null || input === '') return '';

  const parts = input.toString().split('.');
  let integerPart = parts[0];
  const decimalPart = parts.length > 1 ? '.' + parts[1] : '';

  // Apply Indian comma formatting
  const lastThree = integerPart.slice(-3);
  const otherNumbers = integerPart.slice(0, -3);
  const formattedOther = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

  return (otherNumbers ? formattedOther + ',' : '') + lastThree + decimalPart;
};
export const formatToINR = (value) => {
  const cleaned = value.replace(/[^0-9.]/g, "");
  const [intPart, decimalPartRaw] = cleaned.split(".");
  const intNumber = parseInt(intPart || "0", 10);
  const formattedInt = intNumber.toLocaleString("en-IN");
  const decimalPart = (decimalPartRaw || "").substring(0, 2).padEnd(2, "0");
  return `${formattedInt}.${decimalPart}`;
};


export const ListPdfDownload = async (columns = [], formattedData = [], pdf_name = 'assam.pdf', header = [], type = 'l') => {
  if (formattedData.length == 0) {
    var column_title = columns[0]['title']
    formattedData = {}
    formattedData[column_title] = globalThis.config.Settings.Locale == 'en' ? 'No data found' : 'ৰেকৰ্ড পোৱা নাযায়'
    formattedData['_colSpan'] = columns.length - 1
    formattedData = [formattedData]
  }
  const doc = new jsPDF(type);
  const pageWidth = doc.internal.pageSize.getWidth();
  // ------------------ Add Logo -------------------------
  const logoUrl = androidchrome; // Replace with the path to your logo
  const logoWidth = 100; // Width of the logo
  const logoHeight = 20; // Height of the logo
  const padding = 12; // Space from the edge
  let x = padding;
  let y = padding;
  let tableStartY = logoHeight + 20
  doc.addImage(logoUrl, 'PNG', x, y, logoWidth, logoHeight);


  // ------------------------ Set Logo height -------------------------
  const setLogoHeight = 20; // Height of the logo
  const setPadding = 12; // Space from the edge
  const spaceBelowLogo = 7;
  tableStartY = setPadding + setLogoHeight + spaceBelowLogo

  // ------------------ Add Page header 1 ------------------
  if (header[0] != undefined) {
    const header1 = header[0];
    const textWidth = doc.getTextWidth(header1);
    let x = (pageWidth - textWidth) / 2;
    let y = tableStartY;
    tableStartY = tableStartY + 10
    doc.setFont('Banikanta', 'normal');
    doc.text(header1, x, y);
  } // ------------------ Add Page header 2 ------------------
  if (header[1] != undefined) {
    let header1 = header[1];
    let textWidth = doc.getTextWidth(header1);
    let pageWidth = doc.internal.pageSize.getWidth();
    let x = (pageWidth - textWidth) / 2;
    let y = tableStartY;
    tableStartY = tableStartY + 10
    doc.setFont('Banikanta', 'normal');
    doc.text(header1, x, y);
  } // ------------------ Add Page header 3 ------------------
  if (header[2] != undefined) {
    const header1 = header[2];
    const textWidth = doc.getTextWidth(header1);
    const pageWidth = doc.internal.pageSize.getWidth();
    const x = (pageWidth - textWidth) / 2;
    const y = tableStartY;
    tableStartY = tableStartY + 10
    doc.setFont('Banikanta', 'normal');
    doc.text(header1, x, y);
  }
  const tableWidth = pageWidth - 40; // 40 for left and right margins
  const maxDescriptionWidth = 20;
  // if (globalThis.config.Settings.Locale == 'as') {
  doc.autoTable({
    columns,
    body: formattedData,
    startY: tableStartY,
    columnWidth: 20,
    willDrawCell: function (data) {
      doc.setFont('Banikanta', 'normal');
    },
    didParseCell: function (data) {
      data.cell.styles.minCellWidth = columns.length > 10 ? 20 : 30
    }
  });

  doc.save(pdf_name);
}

export const workingBoudaryFilter = (currentUser) => {
  let working_boundary = currentUser.lst_working_boudary[0].working_boundary

  // let zone_ddl_visible = [1].includes(currentUser.lst_working_boudary[0].wing_id)
  // let circle_ddl_visible = [1, 3, 4].includes(currentUser.lst_working_boudary[0].wing_id)
  // let division_ddl_visible = [1, 2, 3, 4].includes(currentUser.lst_working_boudary[0].wing_id)
  // let pa_ddl_visible = [2].includes(currentUser.lst_working_boudary[0].wing_id)
  // let range_ddl_visible = (currentUser.lst_working_boudary[0].range_id == 0 && [1, 2].includes(currentUser.lst_working_boudary[0].wing_id)) ? true : false;
  // let beat_ddl_visible = (currentUser.lst_working_boudary[0].beat_id == 0 && [1].includes(currentUser.lst_working_boudary[0].wing_id)) ? true : false;
  let rewp_ddl_visible = ([4].includes(currentUser.lst_working_boudary[0].wing_id) && currentUser.lst_working_boudary[0].circle_id == 0 && currentUser.lst_working_boudary[0].division_id == 0);

  switch (working_boundary) {
    case "AFD":
      return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    case "Wing":
      return { wing_ddl: false, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    case "Zone":
      return { wing_ddl: false, zone_ddl: false, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    case "Circle":
      return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
    case "Division":
      return { wing_ddl: false, zone_ddl: false, circle_ddl: rewp_ddl_visible, pa_ddl: false, division_ddl: rewp_ddl_visible, range_ddl: true, beat_ddl: true, office_ddl: true }
    case "Range":
      return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: false, beat_ddl: true, office_ddl: true }
    case "Beat":
      return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: false, beat_ddl: false, office_ddl: true }
    case "National Park":
      return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: false, office_ddl: true }
    default:
      return { wing_ddl: false, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  }
  // switch (working_boundary) {
  //   case "AFD":
  //     return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //   case "Wing":
  //     return { wing_ddl: false, zone_ddl: zone_ddl_visible, circle_ddl: circle_ddl_visible, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: true, office_ddl: true }
  //   case "Zone":
  //     return { wing_ddl: false, zone_ddl: false, circle_ddl: circle_ddl_visible, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //   case "Circle":
  //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //   case "Division":
  //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //   case "Range":
  //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: pa_ddl_visible, division_ddl: division_ddl_visible, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //   case "Beat":
  //     return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //   default:
  //     return { wing_ddl: true, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: false, beat_ddl: false, office_ddl: true }
  // }
  // let wing_id = currentUser.lst_working_boudary[0].wing_id;
  // if (wing_id == 1) {
  //   switch (working_boundary) {
  //     case "AFD":
  //       return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Wing":
  //       return { wing_ddl: false, zone_ddl: true, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Zone":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Circle":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Division":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Range":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: true, office_ddl: true }
  //     case "Beat":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //     default:
  //       return { wing_ddl: true, zone_ddl: true, circle_ddl: true, pa_ddl: false, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //   }
  // }
  // else if (wing_id == 2) {
  //   switch (working_boundary) {
  //     case "AFD":
  //       return { wing_ddl: true, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Wing":
  //       return { wing_ddl: false, zone_ddl: true, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Zone":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Circle":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Division":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //     case "Range":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: true, office_ddl: true }
  //     case "Beat":
  //       return { wing_ddl: false, zone_ddl: false, circle_ddl: false, pa_ddl: false, division_ddl: false, range_ddl: range_ddl_visible, beat_ddl: beat_ddl_visible, office_ddl: true }
  //     default:
  //       return { wing_ddl: true, zone_ddl: true, circle_ddl: false, pa_ddl: true, division_ddl: true, range_ddl: true, beat_ddl: true, office_ddl: true }
  //   }
  //}
}

export const assameseToEnglishDigit = (str) => {
  const map = {
    "০": "0",
    "১": "1",
    "২": "2",
    "৩": "3",
    "৪": "4",
    "৫": "5",
    "৬": "6",
    "৭": "7",
    "৮": "8",
    "৯": "9",
  };

  return str
    .split("")
    .map((ch) => (map[ch] !== undefined ? map[ch] : ch))
    .join("");
};


export const gridColumnDisplay = (currentUser) => {
  const workingBoudary = workingBoudaryFilter(currentUser)
  const currentUser_wing_id = currentUser.lst_working_boudary[0].wing_id
  return {
    wing_column: workingBoudary.wing_ddl,
    pa_column: (workingBoudary.pa_ddl && [0, 1].includes(currentUser_wing_id)),
    zone_column: (workingBoudary.zone_ddl && [0, 1].includes(currentUser_wing_id)),
    circle_column: (workingBoudary.circle_ddl && currentUser_wing_id != 2),
    division_column: workingBoudary.division_ddl,
    range_column: (workingBoudary.range_ddl && [0, 1, 2].includes(currentUser_wing_id)),
    beat_column: (workingBoudary.beat_ddl && [0, 1].includes(currentUser_wing_id)),
    office_column: workingBoudary.office_ddl,
  }
}